// extracted by mini-css-extract-plugin
module.exports = {"rates":"_2o1jEIuF","header":"_2SXa40uu","description":"Zje4emH2"};